'use client'

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import { Link } from '@/components/ui/link'
import { trackCta } from '@/lib/analytics/track-cta'

/** Client wrapper: the module card title link, tracking the click before navigating. */
export function ModuleTitleLink({ href, label }: { href: string; label: string }) {
  return (
    <Link
      href={href}
      unstyled
      className="inline-flex items-center gap-1 text-mist-950 hover:underline dark:text-white"
      onClick={() => trackCta('home-module', label)}
    >
      {label} <span aria-hidden="true">→</span>
    </Link>
  )
}
